import { Skeleton } from '@any-ui-react/core';
import type { ReactNode } from 'react';
import { MaterialIcons } from '../material-icons';
import { CardSection } from './CardSection';
import { CardShell } from './CardShell';

export interface CardLoaderProps {
  errorNode?: ReactNode;
  loading?: boolean;
  error?: boolean;
  loaderId?: string;
  message?: ReactNode;
  children?: ReactNode | ReactNode[];
  skeletonChildrenCount?: number;
  loaderClassNames?: {
    card?: string;
    cardWrapper?: string;
    error?: string;
    skeletonWrapper?: string;
  };
}

export const CardLoader = ({
  error,
  loading,
  loaderClassNames,
  children,
  loaderId,
  errorNode = (
    <div className={loaderClassNames?.error}>
      <div className="flex flex-1 items-center justify-center">
        <MaterialIcons iconName="warning" fill={true} className="text-error" />
      </div>
    </div>
  ),
  skeletonChildrenCount = 7,
}: CardLoaderProps) => {
  const node = error ? errorNode : children;
  return (
    <>
      {loading ? (
        <article className={loaderClassNames?.cardWrapper} data-loader-id={loaderId}>
          <CardShell className={`lg:rounded-t-none ${loaderClassNames?.card}`}>
            <CardSection withMargin={false}>
              <fieldset>
                <div
                  className={`grid grid-cols-1 gap-x-4 gap-y-1 lg:grid-cols-2 lg:gap-x-6 ${loaderClassNames?.skeletonWrapper}`}
                >
                  {new Array(skeletonChildrenCount).fill(null).map((_, i) => (
                    <div key={i} className="flex flex-col gap-2">
                      <Skeleton className="inline-flex h-4 w-20" />
                      <Skeleton className="mb-[1.25rem] inline-flex h-8 w-full" />
                    </div>
                  ))}
                </div>
              </fieldset>
            </CardSection>
          </CardShell>
        </article>
      ) : (
        node
      )}
    </>
  );
};
